(function () {
  'use strict';

  // ---------------------------------------------------------------------------
  // YouTube SDK loader
  // Piggybacks on the __slYTBg queue used by hero background videos
  // so the SDK is only ever loaded once per page.
  // ---------------------------------------------------------------------------
  function loadYTScript() {
    if (document.querySelector('script[src*="youtube.com/iframe_api"]')) return;
    var tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    document.head.appendChild(tag);
  }

  function ensureYTReady(callback) {
    // SDK already fully ready
    if (window.YT && window.YT.Player) {
      callback();
      return;
    }

    // Hero background video queue exists – piggyback on it
    if (window.__slYTBg) {
      window.__slYTBg.queue.push(callback);
      if (!window.__slYTBg.loading) {
        window.__slYTBg.loading = true;
        var prevA = window.onYouTubeIframeAPIReady;
        window.onYouTubeIframeAPIReady = function () {
          if (typeof prevA === 'function') prevA();
          window.__slYTBg.queue.forEach(function (fn) { fn(); });
          window.__slYTBg.queue = [];
        };
        loadYTScript();
      }
      return;
    }

    // No background video queue – load the SDK ourselves
    var prevB = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = function () {
      if (typeof prevB === 'function') prevB();
      callback();
    };
    loadYTScript();
  }

  // ---------------------------------------------------------------------------
  // <youtube-modal> custom element
  // ---------------------------------------------------------------------------
  class YoutubeModal extends HTMLElement {
    connectedCallback() {
      this._dialog   = this.querySelector('dialog');
      this._holder   = this.querySelector('[data-yt-holder]');
      this._closeBtn = this.querySelector('[data-yt-close]');
      this._player   = null;
      this._scrollY  = 0;

      if (!this._dialog) return;

      // Global link-click interception
      this._boundPageClick = this._handlePageClick.bind(this);
      document.addEventListener('click', this._boundPageClick);

      // Close button
      if (this._closeBtn) {
        this._closeBtn.addEventListener('click', () => this._close());
      }

      // Clicking the dark backdrop (the <dialog> element itself, outside video)
      this._dialog.addEventListener('click', (e) => {
        if (e.target === this._dialog) this._close();
      });

      // Escape key – prevent native close so we can run our own cleanup
      this._dialog.addEventListener('cancel', (e) => {
        e.preventDefault();
        this._close();
      });
    }

    disconnectedCallback() {
      document.removeEventListener('click', this._boundPageClick);
    }

    // -------------------------------------------------------------------------
    // Intercept any <a href="…youtube…"> click anywhere on the page
    // -------------------------------------------------------------------------
    _handlePageClick(e) {
      var link = e.target.closest('a[href]');
      if (!link) return;
      var videoId = this._getVideoId(link.getAttribute('href'));
      if (!videoId) return;
      e.preventDefault();
      this._open(videoId);
    }

    _getVideoId(url) {
      if (!url) return null;
      var m = url.match(/(?:youtube\.com\/watch\?(?:[^#]*&)?v=|youtu\.be\/)([^&#?]+)/);
      return m ? m[1] : null;
    }

    // -------------------------------------------------------------------------
    // Open modal and start video
    // -------------------------------------------------------------------------
    _open(videoId) {
      // Lock scroll (Horizon pattern)
      this._scrollY = window.scrollY;
      document.body.style.width    = '100%';
      document.body.style.position = 'fixed';
      document.body.style.top      = '-' + this._scrollY + 'px';

      this._holder.innerHTML = '<div id="yt-modal-player"></div>';
      this._dialog.showModal();

      var self = this;
      ensureYTReady(function () {
        self._player = new YT.Player('yt-modal-player', {
          videoId: videoId,
          playerVars: {
            autoplay:        1,
            rel:             0,
            playsinline:     1,
            modestbranding:  1,
          },
          events: {
            onReady: function (e) { e.target.playVideo(); },
          },
        });
      });
    }

    // -------------------------------------------------------------------------
    // Close modal and destroy player
    // -------------------------------------------------------------------------
    _close() {
      if (this._player && typeof this._player.destroy === 'function') {
        this._player.destroy();
        this._player = null;
      }
      this._holder.innerHTML = '';

      if (this._dialog.open) this._dialog.close();

      // Restore scroll (Horizon pattern)
      document.body.style.width    = '';
      document.body.style.position = '';
      document.body.style.top      = '';
      window.scrollTo({ top: this._scrollY, behavior: 'instant' });
    }
  }

  if (!customElements.get('youtube-modal')) {
    customElements.define('youtube-modal', YoutubeModal);
  }
})();
